export default __webpack_public_path__ + "static/media/projeto-aplicado.fbecae15.jpg";